export const initialsFromName = (name: string, numberOfChars: number = 2) => {
  if (!name) {
    return '?';
  }
  name = name
    .trim()
    .toUpperCase()
    .replace(/[^A-ZÁ-Ž ]/g, '') // Remove non letters or spaces.
    .replace(/  +/g, ' '); // Remove more than one consecutive space.

  return name
    .split(' ')
    .map((w) => w[0])
    .slice(0, numberOfChars) // Take first N characters.
    .join('');
};
